const head_CN_Locale = {
    'head.aboutUs': '关于我们',
    'head.products': '产品',
    'head.solution': '解决方案',
    'head.newsUpdates': '新闻动态',
    'head.zh_language': '简体中文',
    'head.en_language': 'English',
    'head.selectLanguage': '选择区域/语言',
    'head.pair': 'Pair丨一站式医学影像专用标注软件',
    'head.cupid': 'CUPID丨产前智能超声筛查系统',
    'head.autoPelvic': 'AutoPelvic丨盆底智能超声筛查系统',
    'head.autoDDH': 'AutoDDH丨婴幼儿髋关节智能超声影像处理系统',
    'head.Breast': 'AutoBreast丨乳腺超声辅助筛查系统',
    'head.AutoThyroid': 'AutoThyroid丨甲状腺超声辅助筛查评估系统',
    'head.AutoCardiac': 'AutoCardiac丨心脏超声智能辅助筛查系统',
    'head.AutoFollicle': 'AutoFollicle丨辅助生殖自动测量系统',
    'head.ATLAS': 'ATLAS丨智能超声质控平台',
    'head.fullStack': '全栈式智能超声解决方案',
    'head.NICE': '超声影像AI部署平台NiCE'
}
export default head_CN_Locale
